import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, LinearProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import ArrowButton from "../../../Components/Common/ArrowButton";
import { DARKCOLORS, LIGHTCOLORS, ROUTES } from "../../../Utils/constants";
import { useThemeContext } from "../../../Context/ThemeContext";
import { getMachineBasicDetails } from "../../../Services/authService";
import SectionLoader from "../../../Components/Common/SectionLoader";
import "./InventoryLevel.css";

function InventoryLevel() {
  const { t } = useTranslation();
  const { mode } = useThemeContext();

  const [machineData, setMachineData] = useState([]);
  const [loading, setLoading] = useState(false);

  const subTextColor =
    mode === "dark"
      ? DARKCOLORS.HeadingLightBackground
      : LIGHTCOLORS.HeadingLightBackground;
  const subTextColor1 =
    mode === "dark"
      ? DARKCOLORS.BodyLightBackground
      : LIGHTCOLORS.BodyLightBackground;


  const containerColor = mode === "dark" ? DARKCOLORS.GreyScale10 : LIGHTCOLORS.GreyScale10;


  
  const colorDanger =
    mode === "dark" ? DARKCOLORS.Danger500 : LIGHTCOLORS.Danger500;
  const colorWarning =
    mode === "dark" ? DARKCOLORS.Warning300 : LIGHTCOLORS.Warning300;
  const colorSuccess =
    mode === "dark" ? DARKCOLORS.Success300 : LIGHTCOLORS.Success300;

  const getColor = (percentage) => {
    if (percentage > 50) return colorSuccess;
    if (percentage > 20) return colorWarning;
    return colorDanger;
  };

 useEffect(() => {
  const fetchMachinesData = async () => {
    try {
      setLoading(true);

      const response = await getMachineBasicDetails();

     const vendingOnlyMachines = response.data.filter(
  (machine) => machine.machineType !== "Return Vending Machine"
);
      setMachineData(vendingOnlyMachines);
    } catch (error) {
      console.error(
        error.message || t("dashboard.errorFetchingMachines")
      );
    } finally {
      setLoading(false);
    }
  };

  fetchMachinesData();
}, []);

  const scroll1 =
    mode === "light"
      ? LIGHTCOLORS.BodyDarkBackground
      : DARKCOLORS.BodyLightBackground;
  const scroll =
    mode === "light" ? LIGHTCOLORS.GreyScale40 : DARKCOLORS.GreyScale40;
  return (
    <Box>
      {/* Header */}
      <Grid container justifyContent="space-between" alignItems="center">
        <h3 className="subheading-sec-card" style={{ margin: "0px" }}>
          {t("dashboard.inventoryLevel")}
        </h3>
        <ArrowButton targetRoute={ROUTES.VENDING_MACHINES} />
      </Grid>

      <Box
        sx={{
          maxHeight: "300px",
          overflowY: "auto",
          marginTop: "16px",
          display: "flex",
          flexDirection: "column",
          gap: "15px",
          // Vertical scrollbar: 5px track, thumb centered via 1px border
          "&::-webkit-scrollbar": {
            width: "10px !important",
            height: "8px !important",
            padding: "2px !important",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: scroll1,
            borderRadius: "10px",
            border: `1px solid ${scroll}`,
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: scroll,
            borderRadius: "10px",
            width: "3px !important",

            border: "3px solid transparent",
            backgroundClip: "padding-box",
            "&:hover": {
              backgroundColor: scroll,
            },
          },
        }}
      >
        {/* Inventory Items */}
        {loading ? (
          <SectionLoader />
        ) : machineData.length === 0 ? (
          <Box>
            <Typography
              colSpan={6}
              align="center"
              sx={{ border: "none", color: subTextColor }}
            >
              {t("dashboard.inventoryLevelError")}
            </Typography>
          </Box>
        ) : (
          machineData.map((item, index) => (
            <Box
              key={index}
              sx={{
                background: containerColor,
                borderRadius: "12px",
                padding: "15px",
                marginRight: "20px",
              }}
            >
              {/* Machine Info */}
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
              >
                <Box
                  sx={{
                    display: "flex",
                    width: "75%",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <p
                    className="label-text-sec hI-level "
                    style={{
                      color: subTextColor,
                      margin: "0px",
                    }}
                  >
                    {item.location} - {item.machineNumber}
                  </p>

                  {/* Low Indicator */}
                  {item.inventoryLevel < 20 && (
                    <Box
                      sx={{
                        backgroundColor: colorDanger,
                        color: "white",
                        padding: "2px 8px",
                        borderRadius: "25px",
                        fontSize: "12px",
                        marginLeft: "8px", // Space between machine number and low indicator
                      }}
                    >
                      {t("dashboard.low")}
                    </Box>
                  )}
                </Box>

                {/* Inventory Percentage */}
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: getColor(item.inventoryLevel),
                  }}
                >
                  {item.inventoryLevel.toFixed(2)}%
                </Typography>
              </Grid>
              <p
                className="add-machine "
                id="machineStreet"
                style={{ color: subTextColor1, margin: "5px 0px" }}
              >
                {item.street}
              </p>

              {/* Progress Bar */}
              <LinearProgress
                variant="determinate"
                value={item.inventoryLevel}
                sx={{
                  marginTop: "8px",
                  height: "6px",
                  borderRadius: "5px",
                  backgroundColor: "#e0e0e0",
                  "& .MuiLinearProgress-bar": {
                    backgroundColor: getColor(item.inventoryLevel),
                  },
                }}
              />
            </Box>
          ))
        )}
      </Box>
    </Box>
  );
}

export default InventoryLevel;
